export const routerUrl = {
  home: '/customer-search',
  dashboard: '/account/dashboard',
  stoneberrycredit: '/account/stoneberrycredit',
  payment: '/account/makepayment',
  thankyouPayment: '/account/makepayment/thankyou',
  orders: '/account/orders',
  orderDetails: '/account/orders/orderdetails',
  address: '/account/addresses',
  profile: '/account/myprofile',
  savedCard: '/account/savedcreditcard',
  wishlist: '/account/wishlist',
  changePassword: '/account/myprofile#changePassword',
  signIn: '/login',
  createAccount: '/register',
  orderStatus: '/orderstatus',
  contactUs: '/contactus',
  resetPassword: '/resetpassword',
  creditLimitPrequalification: '/credit-limit-prequalification',
  creditAccountVerification: '/account/creditaccountverification',
  orderConfirmation: '/account/orderconfirmation',
  dpqSuccess: '/credit-limit-prequalification/prequalscs',
  dpqUnavailable: '/credit-limit-prequalification/prequaluna',
  dpqInternalDecline: '/credit-limit-prequalification/prequalflr',
  buynowpaylater: '/buynowpaylater',
  cart: '/cart',
  account: '/account',
  checkout: '/checkout',
  loginTokenUsed: '/login?tokenUsed=',
  emailChallengeResultSuccess: '/dashboard?',
  errorPayment: '/account/makepayment/error',
  catalogSuccess: '/catalogrequest/success',
  ccpaReqestForm: '/ccparequest',
  ccpaSuccessPage: '/ccparequest/success',
  catalogRequest: '/catalogrequest',
  onlineCatalog: '/onlinecatalog',
  thankYou: '/checkout/thank-you',
  pageNotFound: '/pagenotfound',
};
